import React from "react";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { MapPin, ExternalLink } from "lucide-react";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function LocationMessage({ location }) {
  if (!location) return null;
  const { lat, lng, label } = location;
  const osmUrl = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=17/${lat}/${lng}`;
  return (
    <div className="rounded-xl overflow-hidden border border-slate-200 bg-white max-w-xs">
      <div className="h-32 w-64">
        <MapContainer center={[lat, lng]} zoom={14} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false} zoomControl={false} dragging={false} doubleClickZoom={false}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker position={[lat, lng]} />
        </MapContainer>
      </div>
      <div className="px-3 py-2 border-t border-slate-100 text-xs">
        <div className="flex items-center gap-1 font-semibold text-[#1d3d3a]">
          <MapPin className="w-3 h-3 text-[#e86a24]"/>
          {label || "Posizione condivisa"}
        </div>
        <a href={osmUrl} target="_blank" rel="noreferrer" className="text-[#e86a24] hover:underline inline-flex items-center gap-1 mt-0.5">
          Apri in mappa <ExternalLink className="w-3 h-3"/>
        </a>
      </div>
    </div>
  );
}
